<template>
  <div id="process" class="groupage-cargo-process mt-20">
    <h2>{{ data.title }}</h2>
    <groupage-cargo-process-card
      :title="data.terminalTitle"
      :items="data.terminalList.split(';')"
      img-url="/svg/stock.svg"
      class="mt-30"
    />
    <div class="groupage-cargo-process-wrapper">
      <groupage-cargo-process-card
        :title="data.addressTitle"
        :items="data.addressList.split(';')"
        :description="data.addressText"
        img-url="/svg/address-address.svg"
      />
      <groupage-cargo-process-card
        :title="data.deliveryTitle"
        :items="data.deliveryList.split(';')"
        :description="data.deliveryText"
        img-url="/svg/terminal-address.svg"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCityStore } from '~/stores/city'
import GroupageCargoProcessCard from '~/components/public/groupage-cargo/groupage-cargo-process-card.vue'
import {getPageContent} from '~/api/content'

const { currentCity } = storeToRefs(useCityStore())
const data = (await getPageContent('/groupage-cargo')).blocks?.process
</script>

<style lang="scss" scoped>
.groupage-cargo-process {
  h2 {
    text-align: left;
  }

  &-title {
    font-size: $fs-34;
    line-height: $fs-36;
    text-transform: uppercase;
    font-weight: 700;

    @media only screen and (max-width: $pub-sm) {
      font-size: $fs-30;
    }

    @media only screen and (max-width: $pub-xs) {
      font-size: $fs-28;
    }
  }

  &-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    margin-top: 20px;

    @media only screen and (max-width: $pub-sm) {
      margin-top: 10px;
    }

    @media only screen and (max-width: $pub-sm) {
      grid-template-columns: 1fr;
      grid-gap: 10px;
    }
  }
}
</style>
